import { SVGProps } from 'react';
export const CalendarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M13.1167 2.66667H3.78335C3.04697 2.66667 2.45001 3.26362 2.45001 4V13.3333C2.45001 14.0697 3.04697 14.6667 3.78335 14.6667H13.1167C13.8531 14.6667 14.45 14.0697 14.45 13.3333V4C14.45 3.26362 13.8531 2.66667 13.1167 2.66667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1167 1.33333V4"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.78334 1.33333V4"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.45001 6.66667H14.45"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
